import { Injectable } from '@angular/core';
import { CrmLayoutCollapseProvider } from 'common-module/layout-v2';
import { Observable, of } from 'rxjs';
import { CrmLayoutCollapseConfig } from 'common-module/layout-v2/fragments/collapse/layout-collapse.config';

@Injectable()
export class LayoutCollapseProvider extends CrmLayoutCollapseProvider {
  override getComponentConfig(): Observable<CrmLayoutCollapseConfig> {
    return of({
      text: 'Collapse menu',
      icon: 'menu-fold',
      iconCollapsed: 'menu-unfold',
    });
  }
}
